import util from '../../../util';
import OrderGeneralApi from "../../../api/modules/OrderGeneralApi";

const saveOrderGeneral = (_, payload) => {
  return OrderGeneralApi.saveOrderGeneral(payload.context, payload.payload);
};

const saveOrderGeneralOld = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.post(`/orderGeneral/save`, payload.order, { headers }).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el pedido.')
        reject(error.response)
      }
      reject()
    });
  })
}

const loadOrderGeneral = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/orderGeneral/${payload.idClient}`, { headers }).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar las ordenes.')
      reject(error)
    })
  })
}

const changeOrderGeneral = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
      payload.context.axios.get(`/orderGeneral/changeStatus/${payload.idOrder}/${payload.type}`, { headers }).then((response) => {
        resolve(response.data);
      }).catch(error => {
        util.showDialogError(payload.context, 'Ocurrió un error al cambio de estado.')
        reject(error)
      })
  })
}

const loadStockDetails = ( {commit}, payload ) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/stockOrderGeneral/${payload.idOrder}`, { headers }).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los detalles.')
      reject(error)
    })
  })
}

const loadTracking = ( {commit}, payload ) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/trackingOrderGeneral/${payload.idOrder}`, { headers }).then((response) => {
      resolve(response.data);
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los trackings.')
      reject(error)
    })
  })
}

const recepOrderGeneral = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
      payload.context.axios.get(`/orderGeneral/changeRecep/${payload.idOrder}`, { headers }).then((response) => {
        resolve(response.data);
      }).catch(error => {
        util.showDialogError(payload.context, 'Ocurrió un error al generar el reporte.')
        reject(error)
      })
  })
}

const uptStockOrdGen = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
      payload.context.axios.put(`/stockOrderGen`, payload.pedido, { headers }).then((response) => {
        resolve(response.data);
      }).catch(error => {
        util.showDialogError(payload.context, 'Ocurrió un error al actualziar la observación.')
        reject(error)
      })
  })
}

const listOrdersPickup = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`listOrdersDeliveredWithPendingBoxes/${payload.idClient}`, { headers }).then((response) => {
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar la lista de orden.')
      reject(error)
    });
  })
}

export default {
  saveOrderGeneral,
  loadOrderGeneral,
  changeOrderGeneral,
  loadStockDetails,
  loadTracking,
  recepOrderGeneral,
  uptStockOrdGen,
  listOrdersPickup
};



// WEBPACK FOOTER //
// ./src/store/modules/orderGeneral/actions.js